"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimePicker = void 0;
var react_1 = __importStar(require("react"));
var BlockLabel_1 = require("../../v2/components/BlockLabel");
var getBlockLabelProps_1 = require("../../utils/getBlockLabelProps");
var styled_1 = require("./styled");
var Typo_1 = require("../Typo");
var convertToMiltaryTime_1 = require("./utils/convertToMiltaryTime");
var getNearestTimeToCurrentTime_1 = require("./utils/getNearestTimeToCurrentTime");
var highLightTime_1 = require("./utils/highLightTime");
var handleTimeValidation_1 = require("./handlers/handleTimeValidation");
var convertTo12Hour_1 = require("./utils/convertTo12Hour");
var TimePicker = function (props) {
    var readOnly = props.readOnly, invert = props.invert, disabled = props.disabled, onParentChange = props.onChange, id = props.id, value = props.value;
    var _a = (0, react_1.useState)(value ? (0, convertTo12Hour_1.convertTo12Hour)(value) : null), inputValue = _a[0], setInputValue = _a[1];
    var _b = (0, react_1.useState)(""), errorMessage = _b[0], setErrorMessage = _b[1];
    var inputRef = (0, react_1.useRef)();
    var timeStripRef = (0, react_1.useRef)();
    var timeStripArray = [];
    // generate Time array for dropdown
    for (var hour = 0; hour <= 23; hour++) {
        for (var minute = 0; minute <= 45; minute += 15) {
            var formattedHour = hour % 12 || 12; // Convert to 12-hour format
            var formattedMinute = minute === 0 ? "00" : "".concat(minute);
            var period = hour < 12 ? "AM" : "PM";
            var timeString = "".concat(formattedHour, ":").concat(formattedMinute, " ").concat(period);
            timeStripArray.push(timeString);
        }
    }
    (0, react_1.useEffect)(function () {
        // Function to scroll the element (specific Time) to the top
        var scrollTimeElementToTop = function () {
            var list = timeStripRef.current;
            if (!list)
                return;
            // Find all elements with data-value attribute
            var allListElements = list.querySelectorAll('[data-value]');
            // Initialize variables to keep track of the closest match
            var closestMatch = null;
            var closestMatchValue = Number.MAX_SAFE_INTEGER;
            // Loop through all elements and find the closest match
            allListElements.forEach(function (element) {
                var elementValue = element.getAttribute('data-value');
                if (elementValue.startsWith(inputValue)) {
                    var diff = elementValue.length - inputValue.length;
                    if (diff < closestMatchValue) {
                        closestMatch = element;
                        closestMatchValue = diff;
                    }
                }
            });
            if (!closestMatch) {
                // When there is no exact match, highlight the closest time to the current time
                closestMatch = list.querySelector("[data-value=\"".concat((0, getNearestTimeToCurrentTime_1.getNearestTimeToCurrentTime)(timeStripArray), "\"]"));
            }
            if (closestMatch) {
                (0, highLightTime_1.highLightTime)(closestMatch, invert);
            }
        };
        scrollTimeElementToTop();
    }, [inputValue, timeStripRef]);
    // useEffect(() => {
    //   if(value){
    //     setInputValue(convertTo12Hour(value))
    //   }
    // }, [])
    var handleTimeClick = function (e, item) {
        setInputValue(item);
    };
    var handleOnFocus = function () {
        setInputValue(undefined);
    };
    var handleOnBlur = function () {
        if ((0, convertToMiltaryTime_1.convertToMiltaryTime)(inputValue) === "Invalid time input") {
            setInputValue((0, getNearestTimeToCurrentTime_1.getNearestTimeToCurrentTime)(timeStripArray));
            setErrorMessage(null);
        }
        onParentChange && onParentChange(id, (0, convertToMiltaryTime_1.convertToMiltaryTime)(inputValue));
    };
    var handleInputChange = function (e) {
        var newValue = e.target.value;
        (0, handleTimeValidation_1.handleTimeValidation)(newValue, setErrorMessage, setInputValue);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(BlockLabel_1.BlockLabel, __assign({}, (0, getBlockLabelProps_1.getBlockLabelProps)(props))),
        react_1.default.createElement("div", { style: { display: "flex", position: 'relative' } },
            readOnly ? (react_1.default.createElement(Typo_1.SANS_3, null, inputValue)) : (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(styled_1.StyledTimeInputWrapper, { invert: invert },
                    react_1.default.createElement(styled_1.StyledTimeInput, { type: "test", className: "SANS_3", placeholder: "HH:MM AA", maxLength: "8", invert: invert, value: inputValue, ref: inputRef, autoCapitalize: "characters", onChange: function (e) { return handleInputChange(e); }, onBlur: function () { return handleOnBlur(); }, onFocus: function () { return handleOnFocus(); }, onKeyDown: function (e) {
                            if (e.key === 'Enter') {
                                e.target.blur();
                            }
                        }, disabled: disabled }),
                    react_1.default.createElement(styled_1.StyledDropDown, { className: "drop-down", invert: invert },
                        react_1.default.createElement(styled_1.StyledDropDownList, { className: "drop-list", ref: timeStripRef },
                            " ",
                            timeStripArray.map(function (item) { return (react_1.default.createElement(styled_1.StyledListItem, { "data-value": item, key: item, onMouseDown: function (e) { return handleTimeClick(e, item); }, invert: invert, className: "listElement" },
                                react_1.default.createElement(Typo_1.SANS_3, { invert: invert }, item))); })))))),
            errorMessage && react_1.default.createElement(Typo_1.SANS_0, { color: "red", style: { position: 'absolute', top: '-1.5rem' } }, errorMessage))));
};
exports.TimePicker = TimePicker;
